import COS from '@tencent/new-cos-js-sdk-v5';
import { getNoticeCosConfig } from '../../../../api';
import { ADMIN_PREFIX } from '../../../../api/config';
import { IAPICommonCosConfigRes } from '../../../../model/api-modules';
import { reportPageError } from '../../../lib/bk-report';

let cosConfig: IAPICommonCosConfigRes | undefined = undefined;

export const getCosInstance = (url: string) => {
  return new COS({
    // getAuthorization 必选参数
    getAuthorization(options, callback) {
      // 异步获取临时密钥

      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          const { credentials } = data.data;
          if (!data || !credentials) {
            return console.log('error');
          }
          callback({
            TmpSecretId: credentials.tmpSecretId,
            TmpSecretKey: credentials.tmpSecretKey,
            SecurityToken: credentials.sessionToken,
            // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
            StartTime: data.data.startTime, // 时间戳，单位秒，如：1580000000
            ExpiredTime: data.data.expiredTime, // 时间戳，单位秒，如：1580000000
          });
        })
        .catch((error) => {
          reportPageError(error);
          console.error('Error:', error);
        });
    },
  });
};

export const noticeCOS = getCosInstance(
  `${location.origin}${ADMIN_PREFIX}/cos/sts/notice-system`
);

const getCosConfig = async () => {
  if (!cosConfig) {
    cosConfig = await getNoticeCosConfig();
  }
  return cosConfig;
};

export const putNoticeObject = async (fileName: string, file: File) => {
  await getCosConfig();
  if (!fileName || !cosConfig) {
    return '';
  }
  const fileKey = `${cosConfig.uploadDir}${fileName}`;
  await noticeCOS.putObject({
    Bucket: cosConfig.bucket,
    Region: cosConfig.region,
    Key: fileKey,
    Body: file,
  });
};

export const getNoticeFileUrl = async (fileName?: string) => {
  await getCosConfig();
  if (!fileName || !cosConfig) {
    return '';
  }
  const fileKey = `${cosConfig.uploadDir}${fileName}`;

  const uploadParams = {
    Bucket: cosConfig.bucket,
    Region: cosConfig.region,
    Key: fileKey,
  };
  const url = await new Promise<string>((resolve, reject) => {
    noticeCOS.getObjectUrl(uploadParams, (err, data) => {
      if (err) {
        reject(err);
      }
      resolve(data.Url);
    });
  });
  return url;
};

export const getCosFullURL = (fileName: string) => {
  if (!cosConfig) {
    return '';
  }
  return `https://${cosConfig.bucket}.cos.${cosConfig.region}.myqcloud.com/${cosConfig.uploadDir}${fileName}`;
};
